// jsonobj = [];
// jQuery.getJSON('/cart.js', function(cart) {
//   for (i = 0; i < cart.items.length; i++) {
//     item ={};
//     item['vid']=cart.items[i]['variant_id'];
//     item['quantity']=cart.items[i]['quantity'];
//     jsonobj.push(item);

//   }
// });
//console.log(jsonobj);

$(document).on("click",".Quantity-selector-with-button .btn",function(e){
  var $container = this.$container = $(container);
  var For_this = $(this);
  var sectionId = $container.attr('data-section-id');
  if($(window).width()>576){
    var select = $(this).parents(".product-thumb-caption").find("select.product-form__variants").val();   
    var quantity = $(this).parents(".Quantity-selector-with-button").find(".collection-input-number").val();
  }
  else{
    var select = $(this).parents(".product-thumb-caption").find(".Mobile-selectBox .Singlevalue").attr('value');
    var quantity =1;
  }

  if(quantity == 0 ){

    $(".Notification_Messages").addClass("messages-shown");
    $(".successfull").hide();    
    $(".already-added").hide();
    $(".Invalid").css("display","flex");
    setTimeout(function(){
      $(".Invalid").hide();
      Header_close_notification();      
    },5000);

  }
  else{


    var MaxQuantity = $(this).parents(".product-thumb-caption").find("select.product-form__variants option:selected").attr('data-inventory_quantity');
    var equality= parseInt($(this).parents(".Quantity-with-icons").find(".custom-collection-quantity-selector").attr('data-finalqty')); 

    //     console.log(MaxQuantity);

    if(equality == MaxQuantity ){

      Errormassage();
    }
    else{


      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:{
          id: select,
          quantity: quantity,
        },
        dataType: 'json',
        beforeSend: function(){
        },
        success: function(cart){

          //           console.log('success');
          jQuery.getJSON('/cart.js', function(cartt) {
            var counter = cartt.item_count;
            //             console.log(counter+"--");

          });

          //           console.log(cart);
          var quantity = cart.quantity;
          var title = cart.product_title;
          var v_title = cart.variant_title;
          if(v_title == null){
            var Final_title =title;
          }
          else{
            var Final_title =title +" - "+ v_title;
          }
          $(".Notification_Messages .success .product-added").text(Final_title);
          $(".Notification_Messages").addClass("messages-shown");
          Successdata(e);
          var Finalqty= quantity+' in cart' ;
          For_this.parents(".product-thumb-caption").find(".Quantity-with-icons .custom-collection-quantity-selector").val(Finalqty);
          For_this.parents(".product-thumb-caption").find(".Quantity-with-icons .custom-collection-quantity-selector").attr("data-Finalqty",quantity);
          For_this.parents(".product-thumb-caption").find(".Quantity-with-icons").addClass("after-prod-added");
          For_this.parents(".product-thumb-caption").find(".Quantity-with-icons .already-added").hide();
          For_this.parents(".product-thumb-caption").find(".Quantity-selector-with-button").hide();
        },
        error: function(cart){
          //           console.log('error');
          Errormassage();
        }
      });
    }
  }
});

$(document).on("click",".Notification_Messages .c-ajax",function(e){
  Header_close_notification();
});
$(window).scroll(function(){
  if($(".Notification_Messages").hasClass("messages-shown")){
    Header_close_notification();
  }
});

//   Close Notification Messages
function Header_close_notification(){
  $(".Notification_Messages").removeClass("messages-shown");
}


function Errormassage(){
  setTimeout(function(){
    $(".Notification_Messages").addClass("messages-shown");
    $(".successfull").hide();    
    $(".already-added").css("display","flex");    
    $(".already-added .already-added-content").text("Max Product Limit reached into cart");
  },2000);
  setTimeout(function(){
    Header_close_notification();      
  },5000);
}

function Successdata(e){
  $(".Notification_Messages .Notification_Removed").hide();  
  $(".successfull").show();   
  $(".successfull .success").show();
  $(".already-added").hide();  
  
  e.preventDefault();
  $(e.target).find('input[type=image], input.submit-add-to-cart').attr('disabled', true).addClass('disabled');
  jQuery.getJSON('/cart.js', function(cart) {
    Shopify.updateCart(cart);
    Shopify.updateQuickCart(cart);
    // Shopify.showModal();
  } );
  
  setTimeout(function(){
    Header_close_notification();      
  },5000);

}
$(document).on("click",".increasing-button",function(e){
  var For_this = $(this);
  var qty=$(this).parents(".Quantity-with-icons").find(".custom-collection-quantity-selector").val().replace(/\D/g, ''); 
  var new_quantity = parseInt(qty) + 1;

  if($(window).width()>576){
    var select = $(this).parents(".product-thumb-caption").find("select.product-form__variants").val();
  }
  else{
    var select = $(this).parents(".product-thumb-caption").find(".Mobile-selectBox .Singlevalue").attr('value');
  }


  var MaxQuantity = $(this).parents(".product-thumb-caption").find("select.product-form__variants option:selected").attr('data-inventory_quantity');
  var equality= parseInt($(this).parents(".Quantity-with-icons").find(".custom-collection-quantity-selector").attr('data-finalqty')); 

  //   console.log(MaxQuantity);

  if(equality == MaxQuantity ){

    Errormassage();
  }
  else{


    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data:{
        id: select,
        quantity: new_quantity,
      },
      dataType: 'json',
      beforeSend: function(){
      },
      success: function(cart){
        var quantity = cart.quantity;
        //         console.log('success');
        jsonobj = [];
        jQuery.getJSON('/cart.js', function(cart) {
          var count = 0;
          for (i = 0; i < cart.items.length; i++) {
            item ={};
            item['vid']=cart.items[i]['variant_id'];
            item['quantity']=cart.items[i]['quantity'];
            item["handle"]=cart.items[i]['handle'];
            var TITLE = jQuery.trim(item["handle"]);
            var title = cart.items[i]['product_title'];;
            var v_title = cart.items[i]['variant_title'];
            if(v_title == null){
              var Final_title =title;
            }
            else{
              var Final_title =title +" - "+ v_title;
            }
            if(item['vid']== select){
              count++;
              var Qty =item['quantity'];
              Successdata(e);
              $(".Notification_Messages").addClass("messages-shown");
              $(".Notification_Messages .success .product-added").text(Final_title);
              var Finalqty= Qty+' in cart' ;
              For_this.parents(".product-thumb-caption").find(".Quantity-with-icons .custom-collection-quantity-selector").val(Finalqty);
              For_this.parents(".product-thumb-caption").find(".Quantity-with-icons .custom-collection-quantity-selector").attr("data-Finalqty",Qty);      
            }
            jsonobj.push(item);
          }


        });



      },
      error: function(cart){
        Errormassage();
        //         console.log('error');
      }
    });
  }



});

$(document).on("click",".decreasing-button",function(e){
  var For_this = $(this);
  var qty=$(this).parents(".Quantity-with-icons").find(".custom-collection-quantity-selector").val().replace(/\D/g, ''); 
  var new_quantity = parseInt(qty) - 1;
  if($(window).width()>576){
    var select = $(this).parents(".product-thumb-caption").find("select.product-form__variants").val();
  }
  else{
    var select = $(this).parents(".product-thumb-caption").find(".Mobile-selectBox .Singlevalue").attr('value');
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data:{
      id: select,
      quantity: new_quantity,
    },
    dataType: 'json',
    beforeSend: function(){
    },
    success: function(cart){
      var quantity = cart.item_count;
      var item_count = cart.item_count;
      //       console.log(cart);
      //       console.log('success');
      //       console.log("Total  "+quantity);
      var title = cart.product_title;
      var v_title = cart.variant_title;
      if(v_title == null){
        var Final_title =title;
      }
      else{
        var Final_title =title +" - "+ v_title;
      }
      jsonobj = [];
      jQuery.getJSON('/cart.js', function(cart) {
        var count = 0;
        for (i = 0; i < cart.items.length; i++) {
          item ={};
          item['vid']=cart.items[i]['variant_id'];
          item['quantity']=cart.items[i]['quantity'];
          item["handle"]=cart.items[i]['handle'];
          var TITLE = jQuery.trim(item["handle"]);
          if(item['vid']== select){
            count++;
            var Qty =item['quantity'];
            Successdata(e);
            $(".Notification_Messages .success .product-added").text(Final_title);
            var Finalqty= Qty+' in cart' ;
            For_this.parents(".product-thumb-caption").find(".Quantity-with-icons .custom-collection-quantity-selector").val(Finalqty);
            For_this.parents(".product-thumb-caption").find(".Quantity-with-icons .custom-collection-quantity-selector").attr("data-Finalqty",Qty);      
          }
          jsonobj.push(item);
        }
        if(count == 0){
          For_this.parents(".product-thumb-caption").find(".Quantity-with-icons").removeClass("after-prod-added");
          For_this.parents(".product-thumb-caption").find(".Quantity-selector-with-button").show();
          $(".Notification_Messages").addClass("messages-shown");
          $(".Notification_Messages .Notification_Removed").show();  
          $(".successfull").show();
          $(".successfull .success").hide();
          $(".product-remove").text(Final_title);    
          $(".already-added").hide();  
          setTimeout(function(){
            Header_close_notification();      
          },5000);
        }
      });

      $("span.mega-nav-count.nav-main-cart-amount.count-items").html(item_count);

    },
    error: function(cart){
      Errormassage();
      //       console.log('error');
    }
  });
});


$(document).on('change','.custom-collection-select',function() {
  var getID= $(this).val();
  console.log(getID);
  jsonobj = [];
  jQuery.getJSON('/cart.js', function(cart) {
    var count = 0;
    for (i = 0; i < cart.items.length; i++) {
      item ={};
      item['vid']=cart.items[i]['variant_id'];
      item['quantity']=cart.items[i]['quantity'];
      item["handle"]=cart.items[i]['product_title'];
      var TITLE = jQuery.trim(item["handle"]);
      console.log(item['vid']);
      if(item['vid']== getID){
        console.log('Matched');
        count++;
        var Qty =item['quantity'];
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-selector-with-button").hide();
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-with-icons .custom-collection-quantity-selector").val(Qty +' in cart');
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-with-icons .custom-collection-quantity-selector").attr("data-Finalqty",Qty);      
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-with-icons").addClass('after-prod-added');
      }
      if(count == 0){
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-selector-with-button").show();
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-with-icons").removeClass('after-prod-added');
      }

      jsonobj.push(item);
    }

  });

});	




$(document).on("click",".all-variants .addtocart-popup",function(e){
  $(this).parents(".Override-bootstrap-res").find(".addtocart-popup").removeClass("checked");
  $(this).addClass("checked");
  var Value=$(this).attr('value');
  var Name= $(this).attr("data-name");
  var Price = $(this).find(".vprice").text();
  var Button_textLowerCase = $(this).attr("data-buttontext").toLowerCase();
  var Button_text = $(this).attr("data-buttontext")
  $(this).parents(".Override-bootstrap-res").find('.Main-Product-price').html(Price);
  $(this).parents(".Override-bootstrap-res").find('.Singlevalue').html(Name);
  $(this).parents(".Override-bootstrap-res").find('.Singlevalue').attr("value",Value);

  if(Button_textLowerCase == 'sold out'){
    $(this).parents(".Override-bootstrap-res").find('.collection-button button.collection-btn').addClass("Button-soldout-Disabled");
    $(this).parents(".Override-bootstrap-res").find('.collection-button svg').hide();
    $(this).parents(".Override-bootstrap-res").find('.collection-button .addtocart-btn-text').html(Button_text);
    $(this).parents(".Override-bootstrap-res").find('.collection-button .addtocart-btn-text').addClass("btn-Disabled");
  }
  else{
    $(this).parents(".Override-bootstrap-res").find('.collection-button button.collection-btn').removeClass("Button-soldout-Disabled")
    $(this).parents(".Override-bootstrap-res").find('.collection-button .addtocart-btn-text').html(Button_text);
    $(this).parents(".Override-bootstrap-res").find('.collection-button svg').show();
    $(this).parents(".Override-bootstrap-res").find('.collection-button .addtocart-btn-text').removeClass("btn-Disabled");
  }
  $(this).parents(".Override-bootstrap-res").find('.Variant-Popup-container').removeClass("Popup-opened");  

  var getID= $(this).attr('value');
  jsonobj = [];
  jQuery.getJSON('/cart.js', function(cart) {
    var count = 0;
    for (i = 0; i < cart.items.length; i++) {
      item ={};
      item['vid']=cart.items[i]['variant_id'];
      item['quantity']=cart.items[i]['quantity'];
      item["handle"]=cart.items[i]['handle'];
      var TITLE = jQuery.trim(item["handle"]);
      if(item['vid']== getID){
        count++;
        var Qty =item['quantity'];
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-selector-with-button").hide();
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-with-icons .custom-collection-quantity-selector").val(Qty +' in cart');
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-with-icons .custom-collection-quantity-selector").attr("data-Finalqty",Qty);      
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-with-icons").addClass('after-prod-added');
      }

      if(count == 0){
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-selector-with-button").show();
        $(".product-thumb-caption[data-title='"+TITLE+"']").find(".Quantity-with-icons").removeClass('after-prod-added');
      }

      jsonobj.push(item);
    }

  });

});

$(document).on("click",".Mobile-selectBox",function(e){
  $(this).parents(".Override-bootstrap-res").find('.Variant-Popup-container').addClass("Popup-opened");  
});	
$(document).on("click",".Variant-Popup-container .crossicons",function(e){
  $(this).parents(".Override-bootstrap-res").find('.Variant-Popup-container').removeClass("Popup-opened");  
});	



$(document).mouseup(function (e) {
  var popup = $(".Variant-Popup-container");
  var popup1 = $(".Mobile-selectBox");
  if (!$('.Variant-Popup-container').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
    if (!$('.Mobile-selectBox').is(e.target) && !popup1.is(e.target) && popup1.has(e.target).length == 0) {
      $('.Variant-Popup-container').removeClass("Popup-opened");
    }
  }
});